import { styledDefaultColDef } from '../../../extras/cellRenderers';

export const columnDefs = [
  {
    headerName: 'Job Id',
    field: 'jobId',
    filter: 'agNumberColumnFilter',
    filterParams: {
      numberParser: (text) => {
        return text == null ? null : text;
      },
    },
  },
  {
    headerName: 'Commit Message',
    field: 'commitMessage',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      debounceMs: 200,
    },
  },
  {
    headerName: 'Start Time',
    field: 'startTimeAgo',
  },
  {
    headerName: 'Build Time',
    field: 'buildTime',
  },
  {
    headerName: 'Status',
    field: 'status',
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
